module.exports = { "default": require("core-js/library/fn/json/stringify"), __esModule: true };


/*****************
 ** WEBPACK FOOTER
 ** ./~/.npminstall/babel-runtime/6.11.6/babel-runtime/core-js/json/stringify.js
 ** module id = 10
 ** module chunks = 3
 **/